import Page from "../Common/Page";
import React from "react";
import { Layout } from "antd";
import { Content } from "antd/lib/layout/layout";
import { Messages } from "../Common/ValidateMessages";

export class CompleteChangePasswordPage extends React.Component {
  private _page: React.RefObject<Page>;
  constructor(props) {
    super(props);
    this._page = React.createRef<Page>();
  }

  render() {
    return (
      <>
        <Page
          title="パスワード変更完了"
          ref={this._page}
          noCheckAuthority={true}
        >
          <Layout style={{ padding: "0 24px 24px" }}>
            <Content
              className="site-layout-background"
              style={{
                padding: 24,
                margin: 0,
                minHeight: 280,
              }}
            >
              <h3>{Messages["MSG-001"]}</h3>
            </Content>
          </Layout>
        </Page>
      </>
    );
  }
}
